import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";
import { GoArrowUpRight } from "react-icons/go";

function Footer() {
  return (
    <footer className="bg-white py-4 mt-5">
      <Container>
        <Row>
          <Col md={3}>
            <h5 className="text-dark-blue">My Website</h5>
            <p className="text-muted">
              Your website description goes here.
            </p>

            <div className="d-flex justify-content-left gap-3 mb-3">
               <a href="/" className="text-dark-blue text-decoration-none">Home <GoArrowUpRight/></a>
               <a href="/products" className="text-dark-blue text-decoration-none">About <GoArrowUpRight/></a>
               <a href="/contact" className="text-dark-blue text-decoration-none">Contact <GoArrowUpRight/></a>
            </div>
          </Col>

          <Col md={6}>
            
            <Container fluid className="px-4 px-lg-5">
  <Row className="align-items-center">
    <Col lg={8}>
      <h5 className="text-dark-blue mb-3">Never miss what's next</h5>
       <p className="text-muted mb-4">
        By submitting your email, you’ll be the first to know about upcoming
        updates for Made With Gsap. You can unsubscribe at any time.
      </p>
    </Col>

    <Col lg={7}>
      <Form>
        <div className="d-flex">
          <Form.Control
            type="email"
            placeholder="Enter your email"
            className="rounded-0"
          />
 
          <Button className="rounded-0 px-4 bg-blue-dark">
            Submit
          </Button>
        </div>
      </Form>
    </Col>

    
  </Row>
</Container>
          </Col>

          <Col md={3}>
            <h5 className="text-dark-blue">Contact</h5>
            <p className="text-muted mb-1">Email: admin@middleeastfactories.com</p>
            <p className="text-muted">Phone: +91 94472-57706</p>
            {/* ////// Socail Media ---------------------- */}
             <div className="d-flex justify-content-left gap-3 mb-3">
               <a href="#" className="text-dark-blue fs-5 social-icon">
    <FaFacebookF />
  </a>

  <a href="#" className="text-dark-blue fs-5 social-icon">
    <FaInstagram />
  </a>

  <a href="#" className="text-dark-blue fs-5 social-icon">
    <FaYoutube />
  </a>

  <a href="#" className="text-dark-blue fs-5 social-icon">
    <FaLinkedinIn />
  </a>

  <a href="#" className="text-dark-blue fs-5 social-icon">
    <FaXTwitter />
  </a>
            </div>
          </Col>
        </Row>

        <hr />

        <div className="text-center text-dark-50">
          © {new Date().getFullYear()} My Website. All rights reserved.
        </div>
      </Container>
    </footer>
  );
}

export default Footer;